import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Img } from '../Img/Img.es.js';
import { SkeletonBlock } from '../SkeletonLoader/SkeletonBlock/SkeletonBlock.es.js';

const placeholder = "_placeholder_k4asm_1";
const styles = {
	placeholder: placeholder
};

const ImgSkeletonLoader = (props) => {
  const [ratioWidth, ratioHeight] = (props.aspectRatio || "").split(":").map((part) => {
    return part && parseFloat(part);
  });
  const aspectRatio = ratioWidth && ratioHeight ? ratioWidth / ratioHeight : void 0;
  return jsx(SkeletonBlock, { aspectRatio, height: props.height, width: props.width === null ? void 0 : props.width });
};
const LoadableImg = (props) => {
  const [loaded, setLoaded] = useState(false);
  const onLoad = (event) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(event);
    }
    setLoaded(true);
  };
  return jsxs("div", { "data-zds": true, children: [jsx("div", { className: loaded ? void 0 : styles.placeholder, "data-zds": true, children: jsx(Img, Object.assign({}, props, { onLoad })) }), !loaded && jsx(ImgSkeletonLoader, Object.assign({}, props))] });
};

export { LoadableImg };
//# sourceMappingURL=LoadableImg.es.js.map
